module.exports = __webpack_public_path__ + "img/query-icon-white.f7931a19.svg";